import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { IconLink } from "~misc/icons";
import { db } from "~/db/db";

const RotaDoDiaListagemClienteCard = ({ item, setMarcados, NaosetMarcados, clienteId}) => {
  const [rotasPersistidas, setRotasPersistidas] = useState(false);

  const verificarDataVisita = (data) => {
    const dataMissao = new Date(data);
    const hoje = new Date();

    return (
      dataMissao.getDate() === hoje.getDate() &&
      dataMissao.getMonth() === hoje.getMonth() &&
      dataMissao.getFullYear() === hoje.getFullYear()
    );
  }

  const limparMissoesExpiradas = async () => {
    const todos = await db.missoesStatus.toArray();
    const expirados = todos.filter(item => !verificarDataVisita(item.data));

    if (expirados.length) {
      await db.missoesStatus.bulkDelete(expirados.map(i => i.id));
    }
  };

  const parseMissoesFromVisita = (missoes = "") => {
    const completed = [];
    const notCompleted = [];

    missoes
      .split("\r\n") 
      .map(l => l.trim())
      .filter(Boolean)
      .forEach(l => {
        const campos = l.split(";");

        if (campos.length < 4) return;

        const tipo = campos[0]?.trim();
        const marcado = campos[3] === "1";

        if (!tipo) return;

        if (marcado) {
          completed.push(tipo);
        } else {
          notCompleted.push(tipo);
        }
      });

    return { completed, notCompleted };
  };

  const salvar = async (completed = [], notCompleted = []) => {
    const atual = await db.missoesStatus.get(clienteId);

    const completedSet = new Set([
      ...(atual?.missoes?.completed || []),
      ...completed,
    ]);

    const notCompletedSet = new Set([
      ...(atual?.missoes?.notCompleted || []),
      ...notCompleted,
    ]);

    completed.forEach(tipo => notCompletedSet.delete(tipo));
    notCompleted.forEach(tipo => completedSet.delete(tipo));

    await db.missoesStatus.put({
      id: clienteId,
      missoes: {
        completed: Array.from(completedSet),
        notCompleted: Array.from(notCompletedSet),
      },
      data: Date.now(),
    });

  };

  const [status, setStatus] = useState({ completed: [] ,notCompleted: [] });
  const { completed, notCompleted } = status;

  useEffect(() => {
    if (!clienteId) return;

    
    (async () => {
      await limparMissoesExpiradas();
      
      const rotas = await db.rotas.toArray();
      const rotaCliente = rotas
        .filter(r => String(r.clienteId) === String(clienteId) && r.visita?.data)
        .reduce((maisRecente, atual) => {
          if (!maisRecente) return atual;
          return new Date(atual.visita.data) > new Date(maisRecente.visita.data)
            ? atual
            : maisRecente;
      }, null);

      const missoesVisita = rotaCliente?.visita?.missoes ? parseMissoesFromVisita(rotaCliente.visita.missoes) : { completed: [], notCompleted: [] };
      const local = await db.missoesStatus.get(clienteId);
      const allTipos = item.missoes.map(m => m.tipo);
      
      if (!local && rotaCliente && verificarDataVisita(rotaCliente.visita.data)) {
        const completed = missoesVisita.completed.filter(tipo => allTipos.includes(tipo));
        const notCompleted = missoesVisita.notCompleted.filter(tipo => allTipos.includes(tipo));

        setStatus({ completed, notCompleted });

        return;
      } else {
        setStatus({
          completed: local?.missoes?.completed || [],
          notCompleted: local?.missoes?.notCompleted || [],
        });
        return;
      }
    })();
  }, [clienteId]);

  const handleCheckbox = async (tipo, state) => {
    if (!rotasPersistidas) {
      const local = await db.missoesStatus.get(clienteId);

      if (!local) {
        const rotas = await db.rotas.toArray();
        const rotaCliente = rotas
          .filter(r => String(r.clienteId) === String(clienteId) && r.visita?.data)
          .reduce((maisRecente, atual) => {
            if (!maisRecente) return atual;
            return new Date(atual.visita.data) > new Date(maisRecente.visita.data)
              ? atual
              : maisRecente;
          }, null);
        const missoesVisita = rotaCliente?.visita?.missoes ? parseMissoesFromVisita(rotaCliente.visita.missoes) : { completed: [], notCompleted: [] };

        await db.missoesStatus.put({
          id: clienteId,
          missoes: {
            completed: missoesVisita.completed,
            notCompleted: missoesVisita.notCompleted,
          },
          data: Date.now(),
        });
      }

      setRotasPersistidas(true);
    }

    setStatus(prev => {
      let completed = [...prev.completed];
      let notCompleted = [...prev.notCompleted];

      if (state === "completed") {
        if (completed.includes(tipo)) {
          completed = completed.filter(t => t !== tipo);
        } else {
          completed.push(tipo);
          notCompleted = notCompleted.filter(t => t !== tipo);
        }
      } else {
        if (notCompleted.includes(tipo)) {
          notCompleted = notCompleted.filter(t => t !== tipo);
        } else {
          notCompleted.push(tipo);
          completed = completed.filter(t => t !== tipo);
        }
      }

      salvar(completed, notCompleted);
      return { completed, notCompleted };
    });
  };


  useEffect(() => {
    const missoesAtualizadas = item.missoes
      .filter(m => completed.includes(m.tipo))
      .map(m => ({
        ...m,
        realizada: new Date().toISOString(),
    }));

    setMarcados(prev => ({
      ...prev,
      [item.tipo]: missoesAtualizadas,
    }));

    NaosetMarcados(prev => ({
      ...prev,
      [item.tipo]: item.missoes.filter(m => notCompleted.includes(m.tipo)),
    }));

  }, [completed, notCompleted, item.missoes, item.tipo]);

  const allChecked = item.missoes.length > 0 && item.missoes.every((missao) => completed.includes(missao.tipo));
  const [clickedLinks, setClickedLinks] = useState([]);

  const handleLinkClick = (id) => {
    setClickedLinks((prev) => (prev.includes(id) ? prev : [...prev, id]));
  };

  return (
    <div>
      <div className="listClient">
        <div className="flex flex-col justify-center">
          {item.missoes.map((missao, index) => (
            <div key={missao.id} className="flex justify-between ">
              <div className="listClient__checkboxes mx-3 min-w-18 xl:w-[6.4em] tb:w-[6.2em] xs:w-[5em] w-[5em]">
                <div>
                  <input
                    type="checkbox"
                    checked={completed.includes(missao.tipo)}
                    className={`w-[60px] checkbox-sucess custom-checkbox  ${
                      completed.includes(missao.tipo) ? "checkbox-marked" : ""
                    }`}
                    id={index}
                    onChange={() => handleCheckbox(missao.tipo, "completed")}
                  />
                </div>
              </div>
              <div className="listClient__checkboxes mx-3 min-w-18 xl:w-[6.4em] tb:w-[6.2em] xs:w-[5em] w-[5em]">
                <div>
                  <input
                    type="checkbox"
                    checked={notCompleted.includes(missao.tipo)}
                    className={`w-[60px] checkbox-sucess custom-checkbox checkbox-unmarked`}
                    id={index}
                    onChange={() => handleCheckbox(missao.tipo, "notCompleted")}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className={`rowSpan={itemGrupo.missoes.length} listClient__tipo ${allChecked ? "type" : ""}`}>{item.tipo}</p>

        <div className="flex flex-col items-center justify-center w-full">
          {item.missoes.map((missao) => {
            const link = missao?.link?.split?.(';')[0]?.trim();
            const hasValidLink = link && link !== ";" && link !== "";
            const isClicked = clickedLinks.includes(missao.id);

            return hasValidLink ? (
              <a
                href={link}
                target="_blank"
                key={missao.id}
                onClick={() => handleLinkClick(missao.id)}
                className={`${completed.includes(missao.tipo)
                    ? "direcionamento listClient__description"
                    : "listClient__description"} flex !flex-row justify-center items-center gap-3 cursor-pointer underline ${isClicked ? "text-purple-800" : ""}`}
              >
                {missao.direcionamento}
                <IconLink className="min-w-12" />
              </a>
            ) : (
              <span
                key={missao.id}
                className={`${
                  completed.includes(missao.tipo)
                    ? "direcionamento listClient__description"
                    : "listClient__description"
                }`}
              >
                {missao.direcionamento}
              </span>
            );
          })}
        </div>

        <div className="listClient__hours-content">
          {item.missoes.map((missao) => (
            <p
              key={missao.id}
              className={`${completed.includes(missao.tipo) ? "listClient__hours hours" : "listClient__hours"}`}
            >
              {missao.tempoNecessario}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

RotaDoDiaListagemClienteCard.propTypes = {
  item: PropTypes.shape({
    tipo: PropTypes.string,
    missoes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        direcionamento: PropTypes.string,
        tempoNecessario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        pontos: PropTypes.number,
      })
    ).isRequired,
  }).isRequired,
  setMarcados: PropTypes.func.isRequired,
  NaosetMarcados: PropTypes.func.isRequired,
};

export default RotaDoDiaListagemClienteCard;
